export const Languages = [
    { id: 'en', name: 'English' },
    { id: 'ar', name: 'العربية' },
    { id: 'pt-BR', name: 'Português (Brasil)' }
];

const translations = {
    en: {
        common: {
            language: 'Language',
            yes: 'Yes',
            no: 'No',
            refresh: 'Refresh',
            reset: 'Reset',
            offline: 'Offline',
            offlineHint: 'Looks like you are no longer connected to the Internet. No worries. AzanClock will still work.',
            at: '@',
            am: 'A',
            pm: 'P'
        },
        loading: {
            title: 'Preparing prayer times',
            subtitle: 'AzanClock is getting ready'
        },
        menu: {
            settings: 'Settings',
            recitations: 'Qur\'an Recitations',
            alarms: 'Alarms',
            about: 'About',
            close: 'Close'
        },
        settings: {
            ramadanTipTitle: 'Ramadan Tip:',
            ramadanTipBody: 'Many people add a few extra minutes to the Maghrib offset during Ramadan to ensure sunset has fully occurred. May Allah accept all our fasting.',
            location: 'Set Your Location',
            locationPlaceholder: 'Enter any address or location',
            locationUpdated: 'Your location is updated.',
            detectLocation: 'Detect location automatically',
            locationDetectedDevice: 'Location updated using this device.',
            locationDetectedIp: 'Device location was unavailable. Location updated using the network.',
            locationNotFound: 'Couldn\'t find that location. Please try again.',
            locationOffline: 'Couldn\'t find that location. Please make sure you are connected to Internet and try again.',
            searchLocation: 'Search for this location',
            mapTitle: 'See location on Google Maps',
            calculationMethod: 'Calculation Method',
            asrCalculationMethod: 'Asr Calculation Method',
            displayMode: 'Display Mode',
            screenSaverMode: 'Screen Saver Mode',
            screenSaverDescription: 'Adds gentle motion to the clock and background to help protect always-on displays.',
            displayIntro: 'Choose a layout that stays clear from across the room.',
            zoomedInMode: 'Zoomed In Mode',
            enableAzanCalls: 'Enable Azan Calls & Alarms',
            azan: 'Azan',
            tapToPlay: 'Tap the screen to play the azan',
            minuteOffset: 'Minute Offset',
            tabLocation: 'Location',
            tabDisplay: 'Display',
            tabCalculation: 'Calculation',
            tabAzan: 'Azan',
            tabTimes: 'Times',
            tabDevice: 'Device',
            imsak: 'Imsak',
            duha: 'Duha',
            midnight: 'Midnight'
        },
        clock: {
            elapsed: 'Elapsed',
            next: 'Next',
            in: 'in',
            remainingUntil: ''
        },
        options: {
            auto: 'Auto',
            normal: 'Normal',
            dim: 'Dim',
            standard: 'Standard',
            hanafi: 'Hanafi Late Asr'
        },
        themes: {
            label: 'Display Theme',
            classic: 'Classic',
            noir: 'Noir',
            emerald: 'Emerald',
            minimal: 'Minimal'
        },
        layouts: {
            label: 'Display Layout',
            chooseLayout: 'Choose your clock style',
            clock: 'Prayer Orbit',
            clockDescription: 'A modern prayer ring with a clear digital time and focused current and next prayers.',
            dashboard: 'Prayer Dashboard',
            dashboardDescription: 'Prayer times, dates and daily information in one complete view.'
        },
        dashboard: {
            gregorian: 'Gregorian',
            hijri: 'Hijri',
            current: 'Current',
            next: 'Next',
            now: 'Now',
            currentTime: 'Current time',
            currentPrayer: 'Current prayer',
            prayerWindow: 'Prayer window',
            night: 'Night',
            lastThird: 'Last third',
            daysLeft: 'days left',
            ramadan: 'Ramadan',
            eidFitr: 'Eid al-Fitr',
            eidAdha: 'Eid al-Adha',
            todayPrayers: 'Today\'s prayers',
            quickLinks: 'Quick links',
            duas: 'Adhkar & Duas',
            islamicEvents: 'Islamic events',
            eventsForYear: 'Key Hijri events for',
            eventNote: 'Dates are astronomical estimates. Official moon sighting remains authoritative.',
            startHijriYear: 'Start of Hijri year',
            ashura: 'Ashura',
            mawlid: 'Mawlid an-Nabawi',
            startRamadan: 'Start of Ramadan',
            quranRadioTitle: 'Egypt Quran Radio',
            quranRadioSubtitle: 'Live from Cairo',
            remainingTo: 'Remaining to',
            radioPlay: 'Play live',
            radioStop: 'Stop',
            radioConnecting: 'Connecting...',
            radioLive: 'Live now',
            radioPaused: 'Paused',
            radioPausedForAudio: 'Radio paused until the azan or recitation ends',
            radioUnavailable: 'Live stream is unavailable now'
        },
        recitations: {
            title: 'Qur\'an Recitations',
            collectionHint: 'A selected collection of frequently recited surahs.',
            featuredReciter: 'Featured reciter',
            surahCount: '{count} surahs',
            playSurah: 'Tap to start recitation',
            surahNumber: 'Surah',
            surahPrefix: 'Surah',
            by: 'by',
            source: 'mp3Quran.net',
            startMsg: 'Recitation by {reciter} will begin in about 3 seconds inshaAllah.',
            reciterMaher: 'Shaykh Maher Al-Muaiqly',
            surahs: {
                '018': 'Al-Kahf',
                '032': 'Al-Sajdah',
                '036': 'YaSin',
                '067': 'Al-Mulk',
                '076': 'Al-Insan',
                '078': 'An-Naba'
            }
        },
        media: {
            player: 'Audio player', audio: 'Audio', azan: 'Azan', recitation: 'Qur\'an recitation', reminder: 'Reminder',
            preview: 'Preview', nowPlaying: 'Now playing', paused: 'Paused', play: 'Play', pause: 'Pause', stop: 'Stop',
            rewind: 'Back 5 seconds', progress: 'Audio progress', decreaseOffset: 'Decrease minute offset',
            resetOffset: 'Reset minute offset', increaseOffset: 'Increase minute offset'
        },
        device: {
            title: 'Device information',
            localOnly: 'Shown locally on this device and never sent anywhere.',
            device: 'Device',
            system: 'System & browser',
            totalMemory: 'Estimated RAM',
            appMemory: 'App memory',
            browserLimit: 'Browser limit',
            cores: 'Processor',
            logicalCores: 'Logical cores available to the browser',
            screen: 'Screen resolution',
            viewport: 'App viewport',
            connection: 'Connection',
            online: 'Online',
            offline: 'Offline',
            appStorage: 'App storage',
            availableQuota: 'Browser quota',
            approximate: 'Approximate value reported by the browser',
            browserRestricted: 'This browser does not expose this value',
            unavailable: 'Unavailable',
            memoryNote: 'Web apps cannot read the RAM used by the whole device or by other apps. App-memory figures appear only on supported Chromium browsers.',
            types: { tv: 'Smart TV / TV device', tablet: 'Tablet', mobile: 'Mobile', computer: 'Computer' }
        },
        alarms: {
            addAlarm: 'Alarm',
            addNafl: 'Prayer reminder',
            sound: 'Sound',
            frequency: 'Frequency',
            hour: 'Hour',
            minute: 'Minute',
            minutes: 'Minutes',
            minuteShort: 'min',
            period: 'Period',
            when: 'When',
            prayer: 'Prayer',
            before: 'before',
            after: 'after',
            weekdays: 'Weekdays',
            everyday: 'Everyday',
            save: 'Save',
            savedAlarms: 'Saved alarms',
            twoThirdsNight: '2/3 of Night'
        },
        prayers: {
            Fajr: 'Fajr',
            Sunrise: 'Sunrise',
            Imsak: 'Imsak',
            Duha: 'Duha',
            Duhaend: 'Duha',
            Dhuhr: 'Dhuhr',
            Asr: 'Asr',
            Maghrib: 'Maghrib',
            Isha: 'Isha'
        },
        about: {
            greeting: 'As Salamu Alaykum',
            intro: 'Use AzanClock.com to turn any Android, Amazon Echo or Raspberry Pi device into an actual azan clock.',
            free: 'Free, safe and open source.',
            noSignup: 'No registrations or subscriptions.',
            offline: 'Works even when offline.',
            androidTitle: 'Android or RPi Devices',
            androidBody: 'Add azanclock.com to your home screen and run it.',
            echoTitle: 'Amazon Echo Devices',
            echoBody: 'Say, "Alexa, open Silk browser", navigate to azanclock.com and click on the button to keep it always ON.',
            deviceSuggestions: 'Device suggestions',
            zakatText: 'Calculate and Track Your Zakat Easily',
            officialPage: 'Visit the official AzanClock page',
            privacy: 'Privacy Policy',
            source: 'Open Source Code',
            chrome: 'Prayer Times Chrome Extension',
            version: 'Version'
        }
    },
    ar: {
        common: {
            language: 'اللغة',
            yes: 'نعم',
            no: 'لا',
            refresh: 'تحديث',
            reset: 'إعادة ضبط',
            offline: 'بدون اتصال',
            offlineHint: 'يبدو أنك غير متصل بالإنترنت الآن. لا تقلق، سيستمر AzanClock في العمل.',
            at: 'في',
            am: 'ص',
            pm: 'م'
        },
        loading: {
            title: 'جاري تجهيز مواقيت الصلاة',
            subtitle: 'لحظات ويصبح تطبيق الأذان جاهزًا'
        },
        menu: {
            settings: 'الإعدادات',
            recitations: 'تلاوات القرآن',
            alarms: 'التنبيهات',
            about: 'عن التطبيق',
            close: 'إغلاق'
        },
        settings: {
            ramadanTipTitle: 'تنبيه رمضان:',
            ramadanTipBody: 'كثير من الناس يضيفون دقائق قليلة إلى أذان المغرب في رمضان للتأكد من دخول وقت الغروب. تقبل الله منا ومنكم الصيام.',
            location: 'حدد موقعك',
            locationPlaceholder: 'اكتب العنوان أو المدينة',
            locationUpdated: 'تم تحديث موقعك.',
            detectLocation: 'تحديد الموقع تلقائيًا',
            locationDetectedDevice: 'تم تحديث الموقع باستخدام موقع الجهاز.',
            locationDetectedIp: 'موقع الجهاز غير متاح؛ تم التحديث باستخدام الشبكة.',
            locationNotFound: 'لم نتمكن من العثور على هذا الموقع. حاول مرة أخرى.',
            locationOffline: 'لم نتمكن من العثور على الموقع. تأكد من اتصالك بالإنترنت ثم حاول مرة أخرى.',
            searchLocation: 'البحث عن هذا الموقع',
            mapTitle: 'عرض الموقع على خرائط Google',
            calculationMethod: 'طريقة حساب المواقيت',
            asrCalculationMethod: 'طريقة حساب العصر',
            displayMode: 'وضع العرض',
            screenSaverMode: 'وضع حماية الشاشة',
            screenSaverDescription: 'يحرك الساعة والخلفية بهدوء للمساعدة في حماية الشاشات التي تعمل لفترات طويلة.',
            displayIntro: 'اختر واجهة واضحة ومريحة حتى عند المشاهدة من مسافة بعيدة.',
            zoomedInMode: 'وضع التكبير',
            enableAzanCalls: 'تفعيل الأذان والتنبيهات',
            azan: 'الأذان',
            tapToPlay: 'اضغط على الشاشة لتشغيل الأذان',
            minuteOffset: 'فرق الدقائق',
            tabLocation: 'الموقع',
            tabDisplay: 'العرض',
            tabCalculation: 'الحساب',
            tabAzan: 'الأذان',
            tabTimes: 'الأوقات',
            tabDevice: 'الجهاز',
            imsak: 'الإمساك',
            duha: 'الضحى',
            midnight: 'منتصف الليل'
        },
        clock: {
            elapsed: 'مضى',
            next: 'التالي',
            in: 'بعد',
            remainingUntil: 'يتبقى على'
        },
        options: {
            auto: 'تلقائي',
            normal: 'عادي',
            dim: 'خافت',
            standard: 'قياسي',
            hanafi: 'حنفي - عصر متأخر'
        },
        themes: {
            label: 'ثيم العرض',
            classic: 'كلاسيكي',
            noir: 'ليلي',
            emerald: 'زمردي',
            minimal: 'هادئ'
        },
        layouts: {
            label: 'نظام العرض',
            chooseLayout: 'اختر شكل الساعة',
            clock: 'حلقة الصلوات',
            clockDescription: 'حلقة صلاة حديثة بوقت رقمي واضح وتمييز مباشر للصلاة الحالية والتالية.',
            dashboard: 'لوحة المواقيت',
            dashboardDescription: 'المواقيت والتاريخ ومعلومات اليوم في شاشة واحدة متكاملة.'
        },
        dashboard: {
            gregorian: 'ميلادي',
            hijri: 'هجري',
            current: 'الحالي',
            next: 'التالي',
            now: 'الآن',
            currentTime: 'الساعة الحالية',
            currentPrayer: 'الصلاة الحالية',
            prayerWindow: 'وقت الصلاة',
            night: 'الليل',
            lastThird: 'الثلث الأخير',
            daysLeft: 'يوم متبقي',
            ramadan: 'رمضان',
            eidFitr: 'عيد الفطر',
            eidAdha: 'عيد الأضحى',
            todayPrayers: 'صلوات اليوم',
            quickLinks: 'روابط سريعة',
            duas: 'أذكار وأدعية',
            islamicEvents: 'المناسبات الإسلامية',
            eventsForYear: 'أبرز المناسبات الهجرية لعام',
            eventNote: 'هذه التواريخ فلكية، وتبقى الرؤية الشرعية للهلال هي المعتمدة رسميًا.',
            startHijriYear: 'بداية السنة الهجرية',
            ashura: 'يوم عاشوراء',
            mawlid: 'المولد النبوي الشريف',
            startRamadan: 'بداية شهر رمضان المبارك',
            quranRadioTitle: 'إذاعة القرآن الكريم المصرية',
            quranRadioSubtitle: 'بث مباشر من القاهرة',
            remainingTo: 'باقي على',
            radioPlay: 'تشغيل مباشر',
            radioStop: 'إيقاف',
            radioConnecting: 'جاري الاتصال...',
            radioLive: 'البث يعمل الآن',
            radioPaused: 'تم الإيقاف مؤقتًا',
            radioPausedForAudio: 'تم إيقاف الراديو مؤقتًا حتى انتهاء الأذان أو التلاوة',
            radioUnavailable: 'البث غير متاح الآن'
        },
        recitations: {
            title: 'تلاوات القرآن',
            collectionHint: 'مجموعة مختارة من السور كثيرة الاستماع والتلاوة.',
            featuredReciter: 'القارئ المختار',
            surahCount: '{count} سور',
            playSurah: 'اضغط لبدء التلاوة',
            surahNumber: 'سورة',
            surahPrefix: 'سورة',
            by: 'بصوت',
            source: 'mp3Quran.net',
            startMsg: 'ستبدأ تلاوة {reciter} خلال حوالي 3 ثوانٍ إن شاء الله.',
            reciterMaher: 'الشيخ ماهر المعيقلي',
            surahs: {
                '018': 'الكهف',
                '032': 'السجدة',
                '036': 'يس',
                '067': 'الملك',
                '076': 'الإنسان',
                '078': 'النبأ'
            }
        },
        media: {
            player: 'مشغل الصوت', audio: 'مقطع صوتي', azan: 'الأذان', recitation: 'تلاوة القرآن', reminder: 'تنبيه',
            preview: 'استماع', nowPlaying: 'يعمل الآن', paused: 'متوقف مؤقتًا', play: 'تشغيل', pause: 'إيقاف مؤقت', stop: 'إيقاف',
            rewind: 'رجوع 5 ثوانٍ', progress: 'تقدم المقطع الصوتي', decreaseOffset: 'تقليل فرق الدقائق',
            resetOffset: 'إعادة فرق الدقائق إلى صفر', increaseOffset: 'زيادة فرق الدقائق'
        },
        device: {
            title: 'معلومات الجهاز',
            localOnly: 'تُعرض هذه البيانات على جهازك فقط ولا يتم إرسالها لأي جهة.',
            device: 'نوع الجهاز',
            system: 'النظام والمتصفح',
            totalMemory: 'الرام التقريبي',
            appMemory: 'ذاكرة التطبيق',
            browserLimit: 'حد المتصفح',
            cores: 'المعالج',
            logicalCores: 'الأنوية المنطقية المتاحة للمتصفح',
            screen: 'دقة الشاشة',
            viewport: 'مساحة عرض التطبيق',
            connection: 'الاتصال',
            online: 'متصل بالإنترنت',
            offline: 'بدون اتصال',
            appStorage: 'مساحة التطبيق',
            availableQuota: 'المساحة المسموحة للمتصفح',
            approximate: 'قيمة تقريبية يرسلها المتصفح',
            browserRestricted: 'المتصفح لا يسمح بعرض هذه القيمة',
            unavailable: 'غير متاح',
            memoryNote: 'لا يستطيع تطبيق الويب قراءة الرام المستخدم في الجهاز بالكامل أو في التطبيقات الأخرى. يظهر استهلاك التطبيق فقط في متصفحات Chromium الداعمة.',
            types: { tv: 'تلفزيون ذكي أو جهاز تلفزيون', tablet: 'جهاز لوحي', mobile: 'هاتف', computer: 'كمبيوتر' }
        },
        alarms: {
            addAlarm: 'تنبيه عادي',
            addNafl: 'تنبيه قبل/بعد الصلاة',
            sound: 'الصوت',
            frequency: 'التكرار',
            hour: 'الساعة',
            minute: 'الدقيقة',
            minutes: 'الدقائق',
            minuteShort: 'دقيقة',
            period: 'الفترة',
            when: 'التوقيت',
            prayer: 'الصلاة',
            before: 'قبل',
            after: 'بعد',
            weekdays: 'أيام العمل',
            everyday: 'كل يوم',
            save: 'حفظ',
            savedAlarms: 'التنبيهات المحفوظة',
            twoThirdsNight: 'ثلثا الليل'
        },
        prayers: {
            Fajr: 'الفجر',
            Sunrise: 'الشروق',
            Imsak: 'الإمساك',
            Duha: 'الضحى',
            Duhaend: 'الضحى',
            Dhuhr: 'الظهر',
            Asr: 'العصر',
            Maghrib: 'المغرب',
            Isha: 'العشاء'
        },
        about: {
            greeting: 'السلام عليكم',
            intro: 'استخدم AzanClock.com لتحويل أي جهاز أندرويد أو Amazon Echo أو Raspberry Pi إلى ساعة أذان حقيقية.',
            free: 'مجاني وآمن ومفتوح المصدر.',
            noSignup: 'لا يحتاج إلى تسجيل أو اشتراكات.',
            offline: 'يعمل حتى بدون اتصال بالإنترنت.',
            androidTitle: 'أجهزة Android أو Raspberry Pi',
            androidBody: 'أضف azanclock.com إلى الشاشة الرئيسية ثم شغله.',
            echoTitle: 'أجهزة Amazon Echo',
            echoBody: 'قل: "Alexa, open Silk browser"، ثم افتح azanclock.com واضغط على زر إبقاء الشاشة تعمل دائمًا.',
            deviceSuggestions: 'اقتراحات أجهزة',
            zakatText: 'احسب زكاتك وتابعها بسهولة',
            officialPage: 'زيارة الصفحة الرسمية لتطبيق AzanClock',
            privacy: 'سياسة الخصوصية',
            source: 'الكود مفتوح المصدر',
            chrome: 'إضافة مواقيت الصلاة لمتصفح Chrome',
            version: 'الإصدار'
        }
    },
    'pt-BR': {
        common: {
            language: 'Idioma',
            yes: 'Sim',
            no: 'Não',
            refresh: 'Atualizar',
            reset: 'Redefinir',
            offline: 'Offline',
            offlineHint: 'Parece que você não está mais conectado à internet. Sem problemas, o AzanClock continuará funcionando.',
            at: 'às',
            am: 'AM',
            pm: 'PM'
        },
        loading: {
            title: 'Preparando os horários de oração',
            subtitle: 'O AzanClock estará pronto em instantes'
        },
        menu: {
            settings: 'Configurações',
            recitations: 'Recitações do Alcorão',
            alarms: 'Alarmes',
            about: 'Sobre',
            close: 'Fechar'
        },
        settings: {
            ramadanTipTitle: 'Dica do Ramadan:',
            ramadanTipBody: 'Muitas pessoas adicionam alguns minutos ao ajuste do Maghrib durante o Ramadan para garantir que o pôr do sol já ocorreu. Que Allah aceite nosso jejum.',
            location: 'Defina sua localização',
            locationPlaceholder: 'Digite qualquer endereço ou local',
            locationUpdated: 'Sua localização foi atualizada.',
            detectLocation: 'Detectar localização automaticamente',
            locationDetectedDevice: 'Localização atualizada usando este dispositivo.',
            locationDetectedIp: 'A localização do dispositivo não estava disponível; a rede foi usada.',
            locationNotFound: 'Não foi possível encontrar esse local. Tente novamente.',
            locationOffline: 'Não foi possível encontrar esse local. Verifique sua conexão com a internet e tente novamente.',
            searchLocation: 'Buscar esta localização',
            mapTitle: 'Ver localização no Google Maps',
            calculationMethod: 'Método de cálculo',
            asrCalculationMethod: 'Método de cálculo do Asr',
            displayMode: 'Modo de exibição',
            screenSaverMode: 'Modo protetor de tela',
            screenSaverDescription: 'Move suavemente o relógio e o fundo para ajudar a proteger telas sempre ligadas.',
            displayIntro: 'Escolha um layout claro e confortável mesmo à distância.',
            zoomedInMode: 'Modo ampliado',
            enableAzanCalls: 'Ativar chamadas do azan e alarmes',
            azan: 'Azan',
            tapToPlay: 'Toque na tela para reproduzir o azan',
            minuteOffset: 'Ajuste em minutos',
            tabLocation: 'Local',
            tabDisplay: 'Tela',
            tabCalculation: 'Cálculo',
            tabAzan: 'Azan',
            tabTimes: 'Horários',
            tabDevice: 'Dispositivo',
            imsak: 'Imsak',
            duha: 'Duha',
            midnight: 'Meia-noite'
        },
        clock: {
            elapsed: 'Decorrido',
            next: 'Próximo',
            in: 'em',
            remainingUntil: ''
        },
        options: {
            auto: 'Automático',
            normal: 'Normal',
            dim: 'Escuro',
            standard: 'Padrão',
            hanafi: 'Hanafi - Asr tardio'
        },
        themes: {
            label: 'Tema da tela',
            classic: 'Clássico',
            noir: 'Noir',
            emerald: 'Esmeralda',
            minimal: 'Minimalista'
        },
        layouts: {
            label: 'Layout da tela',
            chooseLayout: 'Escolha o estilo do relógio',
            clock: 'Órbita das orações',
            clockDescription: 'Um anel moderno com hora digital clara e destaque para as orações atual e seguinte.',
            dashboard: 'Painel de orações',
            dashboardDescription: 'Horários, datas e informações do dia em uma única tela.'
        },
        dashboard: {
            gregorian: 'Gregoriano',
            hijri: 'Hijri',
            current: 'Atual',
            next: 'Próximo',
            now: 'Agora',
            currentTime: 'Hora atual',
            currentPrayer: 'Oração atual',
            prayerWindow: 'Período da oração',
            night: 'Noite',
            lastThird: 'Último terço',
            daysLeft: 'dias restantes',
            ramadan: 'Ramadan',
            eidFitr: 'Eid al-Fitr',
            eidAdha: 'Eid al-Adha',
            todayPrayers: 'Orações de hoje',
            quickLinks: 'Links rápidos',
            duas: 'Adhkar e Duas',
            islamicEvents: 'Eventos islâmicos',
            eventsForYear: 'Principais eventos hijri de',
            eventNote: 'As datas são estimativas astronômicas. A observação oficial da lua continua sendo a referência.',
            startHijriYear: 'Início do ano hijri',
            ashura: 'Ashura',
            mawlid: 'Mawlid an-Nabawi',
            startRamadan: 'Início do Ramadan',
            quranRadioTitle: 'Rádio Alcorão do Egito',
            quranRadioSubtitle: 'Ao vivo do Cairo',
            remainingTo: 'Falta para',
            radioPlay: 'Ouvir ao vivo',
            radioStop: 'Parar',
            radioConnecting: 'Conectando...',
            radioLive: 'Ao vivo agora',
            radioPaused: 'Pausado',
            radioPausedForAudio: 'Rádio pausado até o fim do azan ou da recitação',
            radioUnavailable: 'Transmissão indisponível agora'
        },
        recitations: {
            title: 'Recitações do Alcorão',
            collectionHint: 'Uma seleção de suratas frequentemente ouvidas e recitadas.',
            featuredReciter: 'Recitador em destaque',
            surahCount: '{count} suratas',
            playSurah: 'Toque para iniciar a recitação',
            surahNumber: 'Surata',
            surahPrefix: 'Surata',
            by: 'por',
            source: 'mp3Quran.net',
            startMsg: 'A recitação por {reciter} começará em cerca de 3 segundos, inshaAllah.',
            reciterMaher: 'Sheikh Maher Al-Muaiqly',
            surahs: {
                '018': 'Al-Kahf',
                '032': 'As-Sajdah',
                '036': 'YaSin',
                '067': 'Al-Mulk',
                '076': 'Al-Insan',
                '078': 'An-Naba'
            }
        },
        media: {
            player: 'Reprodutor de áudio', audio: 'Áudio', azan: 'Azan', recitation: 'Recitação do Alcorão', reminder: 'Lembrete',
            preview: 'Ouvir', nowPlaying: 'Reproduzindo', paused: 'Pausado', play: 'Reproduzir', pause: 'Pausar', stop: 'Parar',
            rewind: 'Voltar 5 segundos', progress: 'Progresso do áudio', decreaseOffset: 'Diminuir ajuste de minutos',
            resetOffset: 'Redefinir ajuste de minutos', increaseOffset: 'Aumentar ajuste de minutos'
        },
        device: {
            title: 'Informações do dispositivo',
            localOnly: 'Exibidas somente neste dispositivo e nunca enviadas para outro lugar.',
            device: 'Dispositivo',
            system: 'Sistema e navegador',
            totalMemory: 'RAM estimada',
            appMemory: 'Memória do app',
            browserLimit: 'Limite do navegador',
            cores: 'Processador',
            logicalCores: 'Núcleos lógicos disponíveis para o navegador',
            screen: 'Resolução da tela',
            viewport: 'Área do aplicativo',
            connection: 'Conexão',
            online: 'Online',
            offline: 'Offline',
            appStorage: 'Armazenamento do app',
            availableQuota: 'Cota do navegador',
            approximate: 'Valor aproximado informado pelo navegador',
            browserRestricted: 'Este navegador não expõe este valor',
            unavailable: 'Indisponível',
            memoryNote: 'Aplicativos web não podem ler a RAM usada por todo o dispositivo ou por outros apps. A memória do app aparece somente em navegadores Chromium compatíveis.',
            types: { tv: 'Smart TV / dispositivo de TV', tablet: 'Tablet', mobile: 'Celular', computer: 'Computador' }
        },
        alarms: {
            addAlarm: 'Alarme',
            addNafl: 'Lembrete de oração',
            sound: 'Som',
            frequency: 'Frequência',
            hour: 'Hora',
            minute: 'Minuto',
            minutes: 'Minutos',
            minuteShort: 'min',
            period: 'Período',
            when: 'Quando',
            prayer: 'Oração',
            before: 'antes',
            after: 'depois',
            weekdays: 'Dias úteis',
            everyday: 'Todos os dias',
            save: 'Salvar',
            savedAlarms: 'Alarmes salvos',
            twoThirdsNight: '2/3 da noite'
        },
        prayers: {
            Fajr: 'Fajr',
            Sunrise: 'Nascer do sol',
            Imsak: 'Imsak',
            Duha: 'Duha',
            Duhaend: 'Duha',
            Dhuhr: 'Dhuhr',
            Asr: 'Asr',
            Maghrib: 'Maghrib',
            Isha: 'Isha'
        },
        about: {
            greeting: 'As-salamu alaykum',
            intro: 'Use AzanClock.com para transformar qualquer dispositivo Android, Amazon Echo ou Raspberry Pi em um relógio de azan real.',
            free: 'Gratuito, seguro e de código aberto.',
            noSignup: 'Sem cadastro ou assinatura.',
            offline: 'Funciona mesmo offline.',
            androidTitle: 'Dispositivos Android ou Raspberry Pi',
            androidBody: 'Adicione azanclock.com à tela inicial e execute o app.',
            echoTitle: 'Dispositivos Amazon Echo',
            echoBody: 'Diga "Alexa, open Silk browser", acesse azanclock.com e clique no botão para manter a tela sempre ligada.',
            deviceSuggestions: 'Sugestões de dispositivos',
            zakatText: 'Calcule e acompanhe seu zakat com facilidade',
            officialPage: 'Visite a página oficial do AzanClock',
            privacy: 'Política de privacidade',
            source: 'Código aberto',
            chrome: 'Extensão de horários de oração para Chrome',
            version: 'Versão'
        }
    }
};

export const isRtlLanguage = (language) => language === 'ar';

export const getTranslation = (language, key) => {
    const selected = translations[language] || translations.en;
    return key.split('.').reduce((value, part) => value?.[part], selected)
        || key.split('.').reduce((value, part) => value?.[part], translations.en)
        || key;
};
